export default __webpack_public_path__ + "static/media/icons-system-chevron-left.a6b9d24b.svg";